<template>
	<div>

		<div class="btns-top">
			<!-- <a class="btn btn-add fa fa-plus transition-fadeinup" v-on:click="addFieldClickHandler"></a> -->
			<a class="btn btn-submit fa fa-save transition-fadeinup transition-delay-01" v-on:click="submitClickHandler"></a>
		</div>

		<template>
			<div v-if="dataWrapper.fields" class="row">
				<div class="col-20 transition-fadeinup transition-delay-01">

					<div v-if="Object.keys(dataWrapper.fields).length === 0" class="addFirstItem transition-fadeinup">
						<p>Please add some fields.<br><br></p>
						<a class="btn" v-on:click="addFieldClickHandler"><span class="fa fa-plus"></span>Add field</a>
					</div>

				</div>
			</div>
		</template>

		<ul class="data-view form-builder" v-if="dataWrapper.fields && Object.keys(dataWrapper.fields).length !== 0">
			<li class="headings">
				<span>Readable name</span>
				<div class="offset-3">
					<span class="width-300">Type</span>
					<span class="width-100" v-if="addressable">Url</span>
					<span class="width-150">Mandatory</span>
					<span class="width-150">Synced</span>
					<span class="width-150">Max values</span>
					<span class="width-150">CMS</span>
					<span class="width-150" v-if="mainSlug === 'submissions'">Editable</span>
				</div>
			</li>
		</ul>

		<!-- Used for nestable lists -->
		<template v-if="calcDone === true">
			<ul class="data-view form-builder draggable-container main-draggable-container" v-if="dataWrapper.fields && Object.keys(dataWrapper.fields).length !== 0">
				<Field v-for="field in dataWrapper.fieldsTree"
					:key="field.fieldPropertyID"
					:data="field"
					:entity="entity"
					:fields="dataWrapper.fields"
					:openSidebarCallback="openSidebarClickHandler"
					:typeChangedHandlerCallback="typeChangedHandler"
					:changeReferenceDisplayPropertyCallback="changeReferenceDisplayProperty"
					:setFieldSynced="setFieldSynced"
					ref="fieldElement"
				></Field>

				<button class="btn" v-on:click="addFieldClickHandler"><span class="fa fa-plus"></span> Add field</button>
			</ul>
		</template>

		<div class="bubble bubble-delete-confirm">
			<a href="" class="btn red btn-bubble-delete" v-on:click="deleteRecord">Confirm</a>
			<a href="" class="btn black btn-bubble-cancel">Cancel</a>
		</div>

		<Sidebar :type="'objectedit'" ref="sidebar" :data="dataWrapper"></Sidebar>
	</div>
</template>

<script>

import Sidebar from '../../components/sidebars/Sidebar.vue'
import Field from './Field.vue'
import xhrModule from '../../modules/xhrModule.js'
import general from '../../modules/general.js'
import sortable from '../../modules/sortable.js'
import calculateOffsets from '../../modules/calculateOffsets.js'

export default {
	name: 'fields',
	props: {
		entity: Object,
		forms: Object,
		callback: Function
	},
	components: {
		'Sidebar': Sidebar,
		'Field': Field
	},

	watch: {
		entity: function (newVal, oldVal) {
			this.entityFetched = true
			this.loadingDone()
			this.checkAddressable()
		},

		forms: function (newVal, oldVal) {
			this.transformData(newVal)
		}
	},

	data () {
		return {
			mainSlug: general.getMainSlug(),
			addressable: false,
			entityFetched: false,
			formFetched: false,
			calcDone: true,
			dataWrapper: {
				field: null,
				fields: {},
				saveCallbackFunction: this.saveCallback,
				marketOffsetTop: null,
				form: null,
				fieldsTree: []
			}
		}
	},

	created () {
		this.body = document.querySelector('body')
		this.body.classList.add('loading')

		this.loadingInt = 0
		this.fieldInt = 0

		if (this.forms) {
			this.transformData(this.forms)
		}
	},

	updated () {
		this.enableUISort()
	},

	mounted () {
		if (this.entity && this.forms) {
			this.entityFetched = true
			this.formFetched = true
			this.checkAddressable()
		}

		this.loadingDone()
	},

	methods: {
		checkAddressable () {
			if (this.entity.settings.addressable) {
				if (this.entity.settings.addressable.value == 'true') this.addressable = true
			}
		},

		transformData (form) {
			this.dataWrapper.form = this.forms
			this.dataWrapper.fields = {}
			this.formFetched = true
			this.loadingDone()
		},

		loadingDone () {
			if (this.entityFetched && this.formFetched) {
				this.body.classList.remove('loading')

				// only proceed when there are form elements
				if (!this.dataWrapper.form.elements) return

				this.sortFieldsForRender(this.dataWrapper.form.elements)
			}
		},

		sortFieldsForRender (elements) {
			this.calcDone = false

			setTimeout(function () {
				// convert to array
				var propArr = Object.values(elements)

				// sort on priority
				propArr.sort(function (a, b) {
					return a.priority - b.priority
				})

				// create fields object
				this.dataWrapper.fields = {}

				// create tree array we will use to render nested items
				this.dataWrapper.fieldsTree = []

				// keep track of depth
				var depth = []

				// calculate the highest offset right and offset it with 1
				var totalRight = (propArr.length * 2) + 1
				// add main depth
				depth.push({
					obj: this.dataWrapper.fieldsTree,
					left: 1,
					right: totalRight
				})

				for (var i = 0; i < propArr.length; i++) {
					// add field to fiels object
					this.dataWrapper.fields[i] = propArr[i]

					// preprare object for fieldstree
					var obj = {
						'fieldPropertyID': propArr[i].property.id,
						'children': []
					}

					var left = 1
					var right = 2
					let leftProp = null
					let rightProp = null

					if (propArr[i].property.settings) {
						leftProp = propArr[i].property.settings.offset_left
						rightProp = propArr[i].property.settings.offset_right
					} else {
						leftProp = null
						rightProp = null
					}

					if (leftProp) left = parseInt(propArr[i].property.settings.offset_left.value)
					if (rightProp) right = parseInt(propArr[i].property.settings.offset_right.value)

					// Find the correct depth of this item
					for (var d = depth.length - 1; d >= 0; d--) {
						if (left > depth[d].left && right < depth[d].right) {
							var depthLength = depth.length
							var amountOfDepthsToDelete = depthLength - (d + 1)
							if (amountOfDepthsToDelete > 0) depth.splice(d + 1, amountOfDepthsToDelete)
							break
						}
					}

					var lastDepth = depth[depth.length - 1]
					if (lastDepth.obj.children) {
						lastDepth.obj.children.push(obj)
					} else {
						lastDepth.obj.push(obj)
					}

					var difference = right - left
					if (difference !== 1) {
						// create new depth because this item has childs
						depth.push({
							id: propArr[i].property.id,
							left: left,
							right: right,
							obj: obj
						})
					}

					if (i === propArr.length - 1) {
						this.calcDone = true
						this.findReferenceDisplayProperty()
						this.$forceUpdate()
					}
				}
			}.bind(this), 0)
		},

		enableUISort () {
			// destroy for previous instance of sortable
			if (this.sortActive) {
				this.sortableModule.destroy()
				this.sortActive = false
			}

			// enable UI sorting
			var container = document.querySelector('.draggable-container')
			if (container && !this.sortActive) {
				this.sortActive = true
				this.sortableModule = sortable({
					container: null,
					form: true,
					callback: this.sortCompleted.bind(this),
					nestable: true,
					collapsible: false
				})
				this.sortableModule.init()
			}
		},

		sortCompleted: function () {
			var options = {
				callback: this.offsetsCalculated.bind(this),
				addConditionals: true
			}
			// recalculate fieldsTree
			calculateOffsets.init(options)
		},

		offsetsCalculated (childrenTreeArr) {
			// evaluate the synced value for all fields
			// this.evaluateFieldSynchronisation(childrenTreeArr)

			// add correct conditional settings to each field based on the new sort order
			var int = 0
			var length = Object.keys(this.dataWrapper.fields).length
			for (var key in this.dataWrapper.fields) {
				int++
				// when this is a temp ID we will let the server generate an ID on creation
				var propertyID = this.dataWrapper.fields[key].property.id
				if (typeof propertyID === 'string') {
					var index = propertyID.indexOf('temp-')
					if (index > -1) propertyID = 0
				}

				// define priority and add changed offsets if needed
				for (var cta = childrenTreeArr.length - 1; cta >= 0; cta--) {
					if (childrenTreeArr[cta].id == propertyID || childrenTreeArr[cta].id === this.dataWrapper.fields[key].property.id) {
						// change priority
						this.dataWrapper.fields[key].priority = cta + 1

						// add/edit isConditionalParent setting
						if (childrenTreeArr[cta].isConditionalParent === true) {
							var id = 0
							if (this.dataWrapper.fields[key].property.settings.isConditionalParent) id = this.dataWrapper.fields[key].property.settings.isConditionalParent.id
							this.dataWrapper.fields[key].property.settings.isConditionalParent = {
								id: id,
								name: 'isConditionalParent',
								state: 3,
								value: 'true'
							}
						} else if (!childrenTreeArr[cta].isConditionalParent && this.dataWrapper.fields[key].property.settings.isConditionalParent) {
							// remove isConditionalParent settings
							if (this.dataWrapper.fields[key].property.settings.isConditionalParent.id === 0) {
								delete this.dataWrapper.fields[key].property.settings.isConditionalParent
							} else {
								this.dataWrapper.fields[key].property.settings.isConditionalParent.state = 5
							}
						}

						// add/edit conditionalParent setting
						if (childrenTreeArr[cta].conditionalParent) {
							var condPid = 0
							if (this.dataWrapper.fields[key].property.settings.conditionalParent) condPid = this.dataWrapper.fields[key].property.settings.conditionalParent.id
							this.dataWrapper.fields[key].property.settings.conditionalParent = {
								id: condPid,
								name: 'conditionalParent',
								state: 3,
								value: childrenTreeArr[cta].conditionalParent
							}
						} else if (!childrenTreeArr[cta].conditionalParent && this.dataWrapper.fields[key].property.settings.conditionalParent) {
							// remove conditionalParent settings
							if (this.dataWrapper.fields[key].property.settings.conditionalParent.id === 0) {
								delete this.dataWrapper.fields[key].property.settings.conditionalParent
							} else {
								this.dataWrapper.fields[key].property.settings.conditionalParent.state = 5
							}
						}

						// add/edit conditional value setting
						if (childrenTreeArr[cta].conditional === '') {
							var condID = 0
							if (this.dataWrapper.fields[key].property.settings.conditional) condID = this.dataWrapper.fields[key].property.settings.conditional.id

							var value = '[]'
							// check if we already have a value or not
							if (this.dataWrapper.fields[key].property.settings.conditional) value = this.dataWrapper.fields[key].property.settings.conditional.value

							// If the type of the conditional parent is a toggle we will have to add 1 ad conditional value to the child
							for (var key1 in this.dataWrapper.fields) {
								if (this.dataWrapper.fields[key1].property.id == childrenTreeArr[cta].conditionalParent) {
									if (this.dataWrapper.fields[key1].property.settings.type.value === 'Toggle') value = '[1]'
								}
							}
							this.dataWrapper.fields[key].property.settings.conditional = {
								id: condID,
								name: 'conditional',
								state: 3,
								value: value
							}
						} else if (!childrenTreeArr[cta].conditional && this.dataWrapper.fields[key].property.settings.conditional) {
							// remove conditionalParent settings
							if (this.dataWrapper.fields[key].property.settings.conditional.id === 0) {
								delete this.dataWrapper.fields[key].property.settings.conditional
							} else {
								this.dataWrapper.fields[key].property.settings.conditional.state = 5
							}
						}

						// create/edit offset_left
						var offsetLeftID = 0
						if (this.dataWrapper.fields[key].property.settings.offset_left) {
							offsetLeftID = this.dataWrapper.fields[key].property.settings.offset_left.id
						}

						this.dataWrapper.fields[key].property.settings['offset_left'] = {
							'id': offsetLeftID,
							'name': 'offset_left',
							'state': 3,
							'value': childrenTreeArr[cta].offset_left
						}

						// create/edit offset_right
						var offsetRightID = 0
						if (this.dataWrapper.fields[key].property.settings.offset_right) {
							offsetRightID = this.dataWrapper.fields[key].property.settings.offset_right.id
						}

						this.dataWrapper.fields[key].property.settings['offset_right'] = {
							'id': offsetRightID,
							'name': 'offset_right',
							'state': 3,
							'value': childrenTreeArr[cta].offset_right
						}

						break
					}
				}

				if (int === length) {
					this.sortFieldsForRender(this.dataWrapper.fields)
				}
			}
		},

		typeChangedHandler (e) {
			e.preventDefault()

			var target = e.currentTarget
			var val = target.value
			var fieldID = e.currentTarget.getAttribute('data-field')
			var field = null
			for (var key in this.dataWrapper.fields) {
				if (this.dataWrapper.fields[key].property.id == fieldID) {
					field = this.dataWrapper.fields[key]
				}
			}

			// set new type
			field.property.settings.type.value = val

			// enable or disable max values field
			if (['Reference', 'Select', 'Dropzone', 'Multiselect', 'Radio', 'Checkbox'].indexOf(val)) {
				var id = 0
				if (field.property.settings['maxvalues']) id = field.property.settings['maxvalues'].id
				// add max values default to field
				field.property.settings['maxvalues'] = {
					'id': id,
					'name': 'maxvalues',
					'value': 1
				}
			} else {
				// remove max values from field
				if (field.property.settings.maxvalues) {
					// when the field has already been submitted to the back end we cannot delete it
					// we can only set the state to 5
					if (field.property.settings.maxvalues.id > 0) {
						field.property.settings.maxvalues.state = 5
					} else {
						delete field.property.settings.maxvalues
					}
				}
			}

			this.findReferenceDisplayProperty()
			this.$forceUpdate()
		},

		addFieldClickHandler (e) {
			e.preventDefault()

			this.fieldInt++
			var newID = 'temp-' + this.fieldInt

			var field = {
				'id': 0,
				'state': 3,
				'property': {
					'id': newID,
					'name': '',
					'settings': {
						'type': {
							'id': 0,
							'name': 'type',
							'value': 'Textfield'
						},
						'mandatory': {
							'id': 0,
							'name': 'mandatory',
							'value': false
						},
						'synced': {
							'id': 0,
							'name': 'synced',
							'value': false
						},
						'orderinoverview': {
							'id': 0,
							'name': 'orderinoverview',
							'value': 0
						} },
					'translations': {
						'en': {
							'id': 0,
							'market': 1,
							'value': '',
							'state': 3
						}
					}
				}
			}

			// add field to fields object
			this.dataWrapper.fields[newID] = field

			// add field to render tree
			this.dataWrapper.fieldsTree.push({
				'fieldPropertyID': newID,
				'children': []
			})

			this.findReferenceDisplayProperty()
			this.$forceUpdate()
		},

		submitClickHandler (e) {
			e.preventDefault()

			// validate the form fields
			var valid = true
			var int = 0
			var total = Object.keys(this.dataWrapper.fields).length
			for (var field in this.dataWrapper.fields) {
				int++
				var name = this.dataWrapper.fields[field].property.translations.en.value
				if (name === '') {
					this.dataWrapper.fields[field].error = true
					valid = false
				} else {
					this.dataWrapper.fields[field].error = false
				}

				if (int === total) {
					// validation is done
					if (valid) {
						this.prepareDataToPostForm()
					} else {
						// update fields to show errors
						this.updateAllFields()
					}
				}
			}
		},

		prepareDataToPostForm () {
			var options = {
				callback: this.offsetsCompleted.bind(this),
				addConditionals: true
			}
			calculateOffsets.init(options)
		},

		offsetsCompleted: function (childrenTreeArr) {
			// check if there is a form
			// if there is no form we will have to create it
			var formName = 'cms_' + this.entity.name

			// get form id in case is already exists
			var formID = 0
			var formState = 3

			if (this.forms['id']) {
				formID = this.forms.id
				formState = this.forms.state
			}

			// create new form
			var form = {
				'id': formID,
				'name': formName,
				'entity': {
					'id': this.entity.id,
					'name': this.entity.name
				},
				'state': formState,
				'elements': {}
			}

			// add all elements
			var priorityOrder = 0
			var slugsArr = []
			for (var key in this.dataWrapper.fields) {
				// when this is a temp ID we will let the server generate an ID on creation
				var propertyID = this.dataWrapper.fields[key].property.id
				if (typeof propertyID === 'string') {
					var index = propertyID.indexOf('temp-')
					if (index > -1) propertyID = 0
				}

				// define priority and add changed offsets if needed
				for (var cta = childrenTreeArr.length - 1; cta >= 0; cta--) {
					if (childrenTreeArr[cta].id == propertyID || childrenTreeArr[cta].id == this.dataWrapper.fields[key].property.id) {
						// change priority
						priorityOrder = cta + 1

						// create/edit offset_left
						var offsetLeftID = 0
						if (this.dataWrapper.fields[key].property.settings.offset_left) {
							offsetLeftID = this.dataWrapper.fields[key].property.settings.offset_left.id
						}

						this.dataWrapper.fields[key].property.settings['offset_left'] = {
							'id': offsetLeftID,
							'name': 'offset_left',
							'state': 3,
							'value': childrenTreeArr[cta].offset_left
						}

						// create/edit offset_right
						var offsetRightID = 0
						if (this.dataWrapper.fields[key].property.settings.offset_right) {
							offsetRightID = this.dataWrapper.fields[key].property.settings.offset_right.id
						}

						this.dataWrapper.fields[key].property.settings['offset_right'] = {
							'id': offsetRightID,
							'name': 'offset_right',
							'state': 3,
							'value': childrenTreeArr[cta].offset_right
						}

						break
					}
				}

				// define property ID
				var elementID = 0
				if (this.forms['id']) {
					var existingMachienName = this.dataWrapper.fields[key].property.name
					if (this.forms.elements[existingMachienName]) {
						elementID = this.forms.elements[existingMachienName].id
					}
				}

				// If we are using a temp ID then this also means we have to use the newly generated slug
				// When there is an ID genetated by the back end we will have to pick the slug we previously chose
				// Once this has been created this can never change
				var slug = null
				if (propertyID !== 0) {
					slug = this.dataWrapper.fields[key].property.name
				} else {
					slug = general.returnUniqueSlug(this.dataWrapper.fields[key].property.translations.en.value, slugsArr, 0)
				}

				slugsArr.push(slug)

				// When a property has been deleted from the enitity we have to delete it here as well
				var elementState = 3
				if (this.propertyToDelete) {
					if (this.propertyToDelete.indexOf(propertyID.toString()) > -1) elementState = 5
				}

				form.elements[key] = {
					'id': elementID,
					'priority': priorityOrder,
					'state': elementState,
					'property': {
						'id': propertyID,
						'name': slug,
						'settings': this.dataWrapper.fields[key].property.settings
					}
				}

				// add options
				if (this.dataWrapper.fields[key].options) {
					form.elements[key]['options'] = this.dataWrapper.fields[key].options

					// when the options are coming from the back end we get back a lot of data FE is not allowed to post...
					// We will have to strip out that data first
					for (var opt in form.elements[key]['options']) {
						if (form.elements[key]['options'][opt].id !== 0) {
							var translations = form.elements[key]['options'][opt].translations
							for (var translation in translations) {
								if (translations[translation].market.id) {
									translations[translation].market = translations[translation].market.id
								}
							}
						}
					}
				}

				// add translations
				if (this.dataWrapper.fields[key].property.translations) {
					// when the form already exists we get the translations back in the wrong format
					// we need to reformat it back to the correct posting format
					for (var lang in this.dataWrapper.fields[key].property.translations) {
						if (this.dataWrapper.fields[key].property.translations[lang].market.id) {
							this.dataWrapper.fields[key].property.translations[lang].market = this.dataWrapper.fields[key].property.translations[lang].market.id
						}
					}

					form.elements[key].property['translations'] = this.dataWrapper.fields[key].property.translations
				}

				// find the selected reference display property
				if (this.dataWrapper.fields[key].referenceDisplay === true) {
					var referenceID = 0
					form.elements[key].property.settings.referenceDisplayProperty = {
						'id': referenceID,
						'name': 'referenceDisplayProperty',
						'value': '1',
						'state': 3
					}
				}
			}

			var json = JSON.stringify(form)
			var url = '/cms/api/forms'
			xhrModule.post(url, json, this.postFormCompleteHandler.bind(this))
		},

		postFormCompleteHandler (postedForm) {
			// save animation
			general.saveAnimation()

			this.propertyToDelete = []

			this.entityFetched = false
			this.formFetched = false
			// fetch all resources again in the parent component
			this.callback()
		},

		openSidebarClickHandler (e) {
			e.preventDefault()
			// find the offset top for the marker in the sidebar
			this.dataWrapper.marketOffsetTop = e.currentTarget.getBoundingClientRect().top + (e.currentTarget.getBoundingClientRect().height / 2) - 9

			var fieldID = e.currentTarget.getAttribute('data-field-id')
			for (var key in this.dataWrapper.fields) {
				if (this.dataWrapper.fields[key].property.id == fieldID) {
					this.dataWrapper.field = this.dataWrapper.fields[key]
				}
			}
			this.$refs.sidebar.toggle(e.currentTarget)
		},

		saveCallback (changedField, fields) {
			// set aside the properties with options so we can add them back when we post the form
			for (var f = fields.length - 1; f >= 0; f--) {
				if (fields[f].name === changedField.name) {
					fields[f] = changedField
				}
			}

			this.dataWrapper.fields = fields

			this.prepareDataToPostForm()
			this.fieldID = undefined
		},

		deleteRecord (e) {
			e.preventDefault()

			var target = e.currentTarget
			var id = target.getAttribute('data-id')
			if (!this.propertyToDelete) this.propertyToDelete = []
			this.propertyToDelete.push(id)

			// find field with this ID and set the state to 5
			for (var key in this.dataWrapper.fields) {
				if (this.dataWrapper.fields[key].property.id == id) {
					var strID = this.dataWrapper.fields[key].property.id.toString()
					var index = strID.indexOf('temp-')
					if (index > -1) {
						// temp field
						delete this.dataWrapper.fields[key]
					} else {
						// set state to 5
						this.dataWrapper.fields[key].state = 5
						this.updateAllFields()
					}

					setTimeout(function () {
						this.sortCompleted()
					}.bind(this), 500)
					break
				}
			}
		},

		changeReferenceDisplayProperty (e) {
			var target = e.target
			var propertyID = target.getAttribute('data-field-id')

			for (var key in this.dataWrapper.fields) {
				if (propertyID == this.dataWrapper.fields[key].property.id) {
					this.dataWrapper.fields[key].referenceDisplay = true
				} else {
					this.dataWrapper.fields[key].referenceDisplay = false
				}
			}
		},

		findReferenceDisplayProperty: function () {
			// find the value of the referenceDisplayProperty and notify the correct field
			var referenceDisplayProperty = null
			if (this.entity.settings.referenceDisplayProperty) referenceDisplayProperty = this.entity.settings.referenceDisplayProperty
			this.checkIfFieldIsStillQualified(referenceDisplayProperty)
		},

		checkIfFieldIsStillQualified (referenceDisplayProperty) {
			// check if the current reference display property is still qualifies as reference display property
			var qualifiedProp = null
			var int = 0
			var length = Object.keys(this.dataWrapper.fields).length
			for (var key in this.dataWrapper.fields) {
				int++
				if (referenceDisplayProperty) {
					if (this.dataWrapper.fields[key].state === 3 && this.dataWrapper.fields[key].property.id == referenceDisplayProperty.value && this.dataWrapper.fields[key].property.settings.type.value === 'Textfield') {
						qualifiedProp = this.dataWrapper.fields[key]
						this.dataWrapper.fields[key].referenceDisplay = true
					} else {
						this.dataWrapper.fields[key].referenceDisplay = false
					}
				}

				if (int === length) {
					if (!qualifiedProp) {
						this.pickNewReferenceDisplayProperty()
					} else {
						this.updateAllFields()
						this.$forceUpdate()
					}
				}
			}
		},

		pickNewReferenceDisplayProperty () {
			for (var key in this.dataWrapper.fields) {
				// find the first textfield property and set it as the selected reference display
				if (this.dataWrapper.fields[key].property.settings.type.value === 'Textfield' && this.dataWrapper.fields[key].state === 3) {
					this.dataWrapper.fields[key].referenceDisplay = true
					this.updateAllFields()
					this.$forceUpdate()
					break
				}
			}
		},

		updateAllFields () {
			if (this.$refs.fieldElement) {
				for (var i = this.$refs.fieldElement.length - 1; i >= 0; i--) {
					this.$refs.fieldElement[i].rerender()
				}
			}
		},

		setFieldSynced (id) {
			for (var key in this.dataWrapper.fields) {
				if (this.dataWrapper.fields[key].property.id == id) {
					this.dataWrapper.fields[key].property.settings.synced.value = true
					this.$forceUpdate()
					break
				}
			}
		},

		evaluateFieldSynchronisation (childrenTreeArr) {
			// when a conditional parent contains 1 or more synced child(s) we have to set the parent to synced as well
			for (var i = childrenTreeArr.length - 1; i >= 0; i--) {
				if (childrenTreeArr[i].conditionalParent) {
					// when this one has a conditional parent we need to check the current synced status of this field and if it is true we can set the parent to synced as well
				}
			}
		}
	}
}

</script>
